export default __webpack_public_path__ + "static/media/radio.4e481f16.jpg";